/*eslint-disable*/
export const SET_USER_TOKEN = 'setUserToken';
export const SET_USER = 'setUser';
export const SET_HOMEWORK = 'setHomework';
export const SET_HOMEWORK_COPY = 'setHomeworkCopy';
export const SET_GAMES_PARAMETERS = 'setGamesParameters';
export const SET_COURSE = 'setCourse';
export const SET_LESSON_CONDUCTING_TEMPLATE = 'setLessonConductingTemplate';
export const SET_GAME = 'setGame';
export const SET_PARAMS_ARRAY = 'setParamsArray';
export const SET_PREVIOUS_NUMBERS = 'setPreviousNumbers';
export const SET_FIRST_CORRECT_ANSWER = 'setFirstCorrectAnswer';
export const SET_SECOND_CORRECT_ANSWER = 'setSecondCorrectAnswer';
export const SET_PUZZLE_GAMES_PARAMS_ARRAY = 'setPuzzleGamesParamsArray';

export const SET_INTERMEDIATE_STAGE = 'setIntermediateStage';
export const SET_LEVEL_COURSE = 'setLevelCourse';
export const SET_OLYMPIAD = 'setOlympiad';

export const SET_INTERMEDIATE_BATTLE_STAGE = 'setIntermediateBattleStage';
export const SET_BATTLE = 'setBattle';
export const SET_BATTLE_INVITATION = 'setBattleInvitation';
export const SET_BATTLE_DECLINED = 'setBattleDeclined';
export const SET_BATTLE_ACCEPTED = 'setBattleAccepted';
export const SET_BATTLE_PAUSED = 'setBattlePaused';

export const SET_SEARCH_PARAMS = 'setSearchParams';
export const SET_PREVIOUS_ROUTE = 'setPreviousRoute';

export const SET_PUZZLE_GAME = 'setPuzzleGame';
